import { forwardRef, type TextareaHTMLAttributes } from 'react'

import { cn } from '../utilitarios/cn'
import { classesControle } from './campo'

export interface PropriedadesAreaTexto extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  temErro?: boolean
}

export const AreaTexto = forwardRef<HTMLTextAreaElement, PropriedadesAreaTexto>(
  function AreaTexto({ temErro, className, rows = 4, ...resto }, ref) {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(classesControle(temErro), 'py-2 leading-relaxed', className)}
        {...resto}
      />
    )
  },
)

export interface PropriedadesContadorTexto {
  valor: string
  minimo?: number
  maximo?: number
}

/**
 * Contador ao vivo do texto de atendimento (TELA-03 e TELA-05: "Insira ao menos
 * 20 caracteres. N caracteres inseridos.").
 *
 * Conta o texto **aparado**, igual ao `zTextoAtendimento` e ao `CHECK` do banco
 * (`char_length(btrim(mensagem))`): um contador que aceitasse 20 espaços diria
 * "pode enviar" e o servidor devolveria `422 OBSERVACAO_MUITO_CURTA`.
 */
export function ContadorTexto({ valor, minimo = 20, maximo }: PropriedadesContadorTexto) {
  const uteis = valor.trim().length
  const faltam = Math.max(0, minimo - uteis)

  return (
    <span
      className={cn(
        'tabular-nums',
        faltam > 0 ? 'text-atencao' : 'text-sucesso',
        maximo && uteis > maximo && 'text-perigo',
      )}
    >
      {faltam > 0
        ? `Faltam ${faltam} de ${minimo} caracteres`
        : `${uteis} caracteres${maximo ? ` / ${maximo}` : ''}`}
    </span>
  )
}
